<template>
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob"></div>

      <div class="col-lg-12">
        <div class="signup-page--right whiteandround">

          <div class="login-form">
            <div class="logo_form">
            </div>
            <div class="form_title">
              <h1>{{ getTranslations.visitor_sign_up_1_single_country_register_in_steps }}</h1>
            </div>
          </div>

          <div class="signup-form">
            <div class="form-help extra_padng"></div>

            <form action="">
              <input
                v-for="registerButton in registerButtonList"
                :key="registerButton.type"
                :value="getTranslations[registerButton.text]"
                class="one_time btn btn--medium btn--main"
                type="submit"
                @click.prevent="handleSubmit(registerButton.type)"
              />

              <p>
                {{ getTranslations.visitor_sign_up_1_single_country_already_have_account }}
                <router-link :to="'login'">{{ getTranslations.visitor_sign_up_1_single_country_login }}</router-link>
              </p>

              <div v-if="hasSimplify()"
                   class="form-footer-text">
                <span v-for="(key, index) in disclaimers"
                      v-if="getTranslations[key]"
                      :key="index">
                  {{ getTranslations[key] }}
                </span>
              </div>

              <div class="form-footer-text" v-if="showDisclaimer()">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer') }}
              </div>

              <div class="form-footer" v-if="validationForOneTimeSubscription">
                <p>{{ getTranslations.visitor_sign_up_1_single_country_for_daily_sub }}</p>
                <p>{{ getTranslations.visitor_sign_up_1_single_country_for_one_time }}</p>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
    <simplify-registration
      v-if="simpleRegistrationModalConfig.open"
      :text-key="simpleRegistrationModalConfig.textKey"
      @close="handleCloseSimpleRegistrationModal"
    ></simplify-registration>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import SimplifyRegistration from '../../home/modals/SimplifyRegistration';
import integrationMixin from '../../../common/mixins/integration';
import flowMixin from '../../..//common/mixins/flow';
import subscriptionMixin, {
  subscriptionOperationEnum,
  subscriptionTypeEnum,
} from '../../../common/mixins/subscription';

export default {
  name: 'RegisterViaSms',
  components: { SimplifyRegistration },
  mixins: [
    integrationMixin,
    flowMixin,
    subscriptionMixin,
  ],
  data () {
    return {
      registerButtonList: [
        { type: subscriptionTypeEnum.DAILY, text: 'visitor_sign_up_1_single_placeholder_daily_subscription' },
        { type: subscriptionTypeEnum.ONE_TIME, text: 'visitor_sign_up_1_single_placeholder_one_time_subscription' },
      ],
      simpleRegistrationModalConfig: { open: false, textKey: undefined },
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3'],
    };
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    validationForOneTimeSubscription () {
      return (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.oneTimeSubscription;
    },
  },
  methods: {
    showDisclaimer () {
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer');
    },
    handleSubmit (subscriptionType) {
      this.subscriptionMixinLaunchAction(
        subscriptionOperationEnum.REGISTER,
        subscriptionType,
        value => {
          this.simpleRegistrationModalConfig.open = true;
          this.simpleRegistrationModalConfig.textKey = value;
        },
      );
    },
    handleCloseSimpleRegistrationModal () {
      this.simpleRegistrationModalConfig.open = false;
      this.simpleRegistrationModalConfig.textKey = undefined;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/RegisterViaSms.vue